<li *ngIf="type === categoryTreeTypeEnum.listCRUD && isShow">
  <div class="border fix-double-border p-2">
    <btn
      [btnType]="'button'"
      [classes]="['btn-first', 'mr-3', 'ml-1']"
      (onEvent)="subcategoriesShow()"
      [icon]="(subcategories && subcategories.length > 0 && showSubcategories) ? 'far-minus' : 'far-plus'"
      [btnDisabled]="!category.hasChildren"
    ></btn>
    <span>{{ category.name }}</span>
    <btn
      *ngIf="isCategoryEditable"
      [btnType]="'button'"
      [classes]="['btn-first', 'float-right']"
      [routerLink]="['/category', category.id]"
      [icon]="'far-pencil'"
      [title]="'edit' | translate"
      data-cy="edit-category"
    ></btn>
    <btn
      *ngIf="isCategoryEditable"
      [btnType]="'button'"
      [classes]="['btn-first-red', 'float-right', 'mr-2']"
      (onEvent)="categoryDelete()"
      [icon]="'far-trash-alt'"
      [title]="'delete' | translate"
      data-cy="delete-row-category"
    ></btn>
  </div>
  <ul
    class="list-unstyled pl-3"
    dndDropzone
    dndEffectAllowed="move"
    (dndDrop)="onDrop($event, subcategories, category)"
  >
    <li dndPlaceholderRef class="categoriesListDndPlaceholder"></li>
    <ng-container *ngIf="subcategories && subcategories.length > 0 && showSubcategories">
      <category-tree-row
        *ngFor="let subcategory of subcategories"
        [disabled]="disabled"
        [isCategoryEditable]="isCategoryEditable"
        [category]="subcategory"
        [type]="categoryTreeTypeEnum.listCRUD"
        [dndDraggable]="subcategory"
        dndEffectAllowed="move"
        (dndMoved)="onDragMove(subcategory, subcategories)"
      ></category-tree-row>
    </ng-container>
  </ul>
</li>

<li *ngIf="type === categoryTreeTypeEnum.radioParentCategory">
  <div class="d-flex align-items-baseline">
    <i
      class="fa fa-times position-relative cursor-pointer category-unset"
      [ngClass]="{
        invisible: !isRadioSelected(radioInput),
        'category-unset-with-subcategories': category.hasChildren,
        'category-unset-without-subcategories': !category.hasChildren
      }"
      (click)="unsetCategory(radioInput)"
    ></i>
    <i
      #arrowIconRadioParentCategory
      class="fa fa-caret-down mr-2 cursor-pointer category-unset"
      [ngClass]="{ invisible: !category.hasChildren }"
      (click)="subcategoriesShow()"
      [id]="category.id"
    ></i>
    <input
      #radioInput
      type="radio"
      [ngModel]="checkedCategory"
      [name]="'parentCategory'"
      [value]="category.id"
      (ngModelChange)="onNgModelChange(category)"
      [readonly]="disabled"
      [id]="'parent_category_' + category.id"
    />
    <label class="ml-2" [for]="'parent_category_' + category.id">{{ category.name }}</label>
  </div>
  <ul *ngIf="subcategories.length > 0 && showSubcategories" class="list-unstyled ml-3">
    <category-tree-row
      [disabled]="disabled"
      *ngFor="let subcategory of subcategories"
      [category]="subcategory"
      [(editedCategory)]="editedCategory"
      [type]="categoryTreeTypeEnum.radioParentCategory"
    ></category-tree-row>
  </ul>
</li>

<li *ngIf="type === categoryTreeTypeEnum.radioProductMainCategory">
  <div class="d-flex align-items-baseline">
    <i
      class="fa fa-times position-relative cursor-pointer category-unset"
      [ngClass]="{
        invisible: !isRadioSelected(radioInput),
        'category-unset-with-subcategories': category.hasChildren,
        'category-unset-without-subcategories': !category.hasChildren
      }"
      (click)="unsetCategory(radioInput)"
      *ngIf="!disabled"
    ></i>
    <i
      #arrowIconRadioProductMainCategory
      class="fa fa-caret-down mr-2 cursor-pointer"
      [ngClass]="{ invisible: !category.hasChildren }"
      (click)="subcategoriesShow()"
      [id]="category.id"
    ></i>
    <input
      #radioInput
      type="radio"
      [ngModel]="checkedCategory"
      [name]="'productMainCategory'"
      [value]="category.id"
      (ngModelChange)="onNgModelChange(category)"
      [readonly]="disabled"
      [id]="'main_category_' + category.id"
    />
    <label class="ml-2" [for]="'main_category_' + category.id">{{ category.name }}</label>
  </div>
  <ul *ngIf="subcategories.length > 0 && showSubcategories" class="list-unstyled ml-3">
    <category-tree-row
      *ngFor="let subcategory of subcategories"
      [category]="subcategory"
      [(selectedCategories)]="selectedCategories"
      (mainCategoryChange)="onNgModelChange($event)"
      [mainCategory]="mainCategory"
      [type]="categoryTreeTypeEnum.radioProductMainCategory"
      [disabled]="disabled"
    ></category-tree-row>
  </ul>
</li>

<li *ngIf="type === categoryTreeTypeEnum.checkboxProductCategories" class="category-tree-row-bulk-edit">
  <div class="d-flex align-items-baseline">
    <i
      #arrowIconCheckboxProductCategories
      class="fa fa-caret-down mr-2 cursor-pointer"
      [ngClass]="{ invisible: !category.hasChildren }"
      (click)="subcategoriesShow()"
      [id]="category.id"
    ></i>
    <form-row-checkbox
      [isInBulkEdits]="isInBulkEdits"
      [label]="category?.name"
      [ngModel]="checkedCategory"
      [name]="'productCategories'"
      (ngModelChange)="onNgModelChangeCheckbox($event, category)"
      [id]="'product_categories_' + category.id"
      [inputDisabled]="disabled">
    </form-row-checkbox>
  </div>
  <ul *ngIf="subcategories.length > 0 && showSubcategories" class="list-unstyled ml-3">
    <category-tree-row
      *ngFor="let subcategory of subcategories"
      [category]="subcategory"
      [selectedCategories]="selectedCategories"
      (selectedCategoriesChange)="selectedCategoriesChanged($event)"
      [type]="categoryTreeTypeEnum.checkboxProductCategories"
      [disabled]="disabled"
    ></category-tree-row>
  </ul>
</li>
